import axios from "axios";

// Frontend and /api share one deployment, so the page's own origin always works (apex, www, emergent.host, preview); local dev keeps the env URL.
const LOCAL = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/.test(window.location.hostname);
export const BACKEND_URL = LOCAL ? process.env.REACT_APP_BACKEND_URL : window.location.origin;
export const API = `${BACKEND_URL}/api`;

const withWord = (p) => ({ ...p, description: p.emotion, emotion: p.feeling_word || p.emotion });
export const fetchPaintings = async () => (await axios.get(`${API}/paintings`)).data.map(withWord);
export const fetchSettings = async () => (await axios.get(`${API}/settings`)).data;
export const fetchNotes = async (id) => (await axios.get(`${API}/paintings/${id}/notes`)).data;
export const fetchMemories = async () => (await axios.get(`${API}/memories`)).data;
export const fetchOpening = async () => (await axios.get(`${API}/opening`)).data;
let libPromise = null;
export const fetchLibrary = () => (libPromise ||= axios.get(`${API}/music/library`).then((r) => r.data).catch((e) => ((libPromise = null), Promise.reject(e))));
export const postNote = async (id, body) => (await axios.post(`${API}/paintings/${id}/notes`, body)).data;

export const deviceId = () => {
  let id = localStorage.getItem("afae-device");
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`).slice(0, 60);
    localStorage.setItem("afae-device", id);
  }
  return id;
};

export function errText(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
}

export const imageSrc = (url) => (/^https?:\/\//.test(url) ? url : `${BACKEND_URL}${url}`);

export const sceneImage = (name) => `${process.env.PUBLIC_URL || ""}/scenes/${name}`;

let webglOk = null;
// Probe once and release the probe context: browsers cap live WebGL contexts and evict the gallery's first.
export function hasWebGL() {
  if (new URLSearchParams(window.location.search).has("nowebgl")) return false;
  if (webglOk !== null) return webglOk;
  try {
    const c = document.createElement("canvas");
    const gl = window.WebGLRenderingContext && (c.getContext("webgl2") || c.getContext("webgl"));
    webglOk = !!gl;
    gl?.getExtension("WEBGL_lose_context")?.loseContext();
  } catch {
    webglOk = false;
  }
  return webglOk;
}

export const isTouchDevice = () =>
  window.matchMedia?.("(pointer: coarse)").matches || "ontouchstart" in window || window.innerWidth < 768;
